import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'date2'
})
export class Date2Pipe implements PipeTransform {

  transform(value: string, format?: any): any {
    if (!value || value == '0000-00-00' || value == '0000-00-00 00:00:00' || value.toLowerCase() == 'invalid date') {
      return '';
    }

    return new DatePipe('en-US').transform(value, format);
  }

}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/pipes/date2.pipe.ts